import { ObjectPropertyType } from '../Models/ObjectPropertyType';
import { JsonSchemaModel } from '../Models/JsonSchemaModel';
import { VariableScope } from '../Models/VariableScopes/VariableScope';
import { convertJsonSchemaPropertyToEntityProperty, getJsonSchemaFromProperty } from './EntityMetadataModelConverter';

export function scopeFingerprint(scope: VariableScope): string {
	return JSON.stringify([
		Array.from(scope.getVariables()).sort(([a], [b]) => a.localeCompare(b)).map(([name, variable]) => [
			name, getJsonSchemaFromProperty(variable), !!variable.isRequired,
			!!variable.possiblyUnavailable, [...(variable.scopeOrigins ?? [])].sort(),
		]),
		scope.getDiagnostics().sort(),
	]);
}

export function mergeScopeBranches(scopes: VariableScope[]): VariableScope {
	const result = new VariableScope();
	const names = new Set(scopes.flatMap((scope) => Array.from(scope.getVariables().keys())));
	for (const name of Array.from(names)) {
		const values = scopes.map((scope) => scope.getVariable(name));
		const present = values.filter((value): value is ObjectPropertyType => !!value);
		const alternatives = new Map<string, JsonSchemaModel>();
		for (const value of present) {
			const schema = getJsonSchemaFromProperty(value);
			const branches = schema.anyOf && Object.keys(schema).length === 1 ? schema.anyOf : [schema];
			for (const branch of branches) alternatives.set(JSON.stringify(branch), branch);
		}
		const schemas = Array.from(alternatives).sort(([a], [b]) => a.localeCompare(b)).map(([, value]) => value);
		const definite = present.length === scopes.length && present.every((value) => value.isRequired !== false && !value.possiblyUnavailable);
		const value = schemas.length === 1
			? { ...present[0], isRequired: definite }
			: convertJsonSchemaPropertyToEntityProperty(name, { anyOf: schemas }, definite);
		result.setVariable(name, {
			...value,
			possiblyUnavailable: !definite,
			scopeOrigins: Array.from(new Set(present.flatMap((item) => item.scopeOrigins ?? []))).sort(),
		});
	}
	for (const scope of scopes) {
		for (const message of scope.getDiagnostics()) result.addDiagnostic(message);
	}
	return result;
}
